import { Box } from '@chakra-ui/react';
import { QrCodeIcon } from '@halo/ui-chat-react';
import type { User } from '@halo/chat-sdk-react';
import { useAppStore } from '@halo/chat-sdk-react';
import { useActionsStore } from '@/store/actions';

interface QrCodeButtonProps {
  user: Pick<User, 'avatar' | 'name' | 'username'> & { user_id?: string; group_id?: string };
  source: 'group' | 'user';
}

export const QrCodeButton = ({ user, source }: QrCodeButtonProps) => {
  const { setQrCodeIsOpen } = useActionsStore();
  const { client } = useAppStore();
  const handleViewQrCode = useCallback(() => {
    client?.Api.http
      .getShareUrl({ user_id: user?.user_id, group_id: user?.group_id })
      .then(({ url }) => {
        setQrCodeIsOpen(true, {
          link: url || '',
          avatar: user?.avatar || '',
          name: user?.name || '',
          username: user?.username || '',
          source,
        });
      });
  }, [
    client?.Api.http,
    setQrCodeIsOpen,
    user?.avatar,
    user?.name,
    user?.user_id,
    user?.group_id,
    user?.username,
    source,
  ]);
  return (
    <Box
      cursor="pointer"
      p="1.5"
      rounded="xl"
      bg="grey.50"
      fontSize="lg"
      onClick={handleViewQrCode}
    >
      <QrCodeIcon />
    </Box>
  );
};

export default QrCodeButton;
